/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：285__part-2
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_107 from /* 107 */"../../107"
function I(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (null === n || undefined === n) {
      return
    }
    n = n[t[r]]
  }
  return n
}
export { I }
